import React, {Fragment} from 'react';
import {Button, Grid} from 'semantic-ui-react';

import BreakCardGroup from 'components/homepage-layouts/items/break-card-group';
import AddHomepageItemModalContainer from 'components/homepage-layouts/items/AddItemModal/AddItemModalContainer';
import HomepageHeroSection from 'components/homepage-layouts/items/hero-section';
import HomepageMessageBar from 'components/homepage-layouts/items/message-bar';

const components = {
  'BREAK_CARD_GROUP': BreakCardGroup,
  'HERO': HomepageHeroSection,
  'MESSAGE_BAR': HomepageMessageBar
}

class HomepageColumn extends React.Component {

  render() {
    return  <Grid.Column>
              {this.props.column.items ?
                <Fragment>
                {this.props.column.items.map((item, i) => {
                  let ItemComponent = components[item.type];
                  return <ItemComponent item={item} />
                })}
                </Fragment>
              : "" }
              <Button onClick={() => {this.props.showAddItemModal(this.props.column.id, this.props.section.id);} }>Add Item</Button>
              <AddHomepageItemModalContainer  key="homepageLayoutAddItemModal"/>
            </Grid.Column>
  }

}

export default HomepageColumn;



// WEBPACK FOOTER //
// ./public/components/homepage-layouts/HomepageColumn.jsx